export default __webpack_public_path__ + "static/media/aggiorna_esistente_2x.59bfd1aa.png";